import CronogramaTableV2 from "../CronogramaTableV2";

// Na visão do professor a célula mostra a turma (descrição curta, se houver) e o local.
const detalheTurmaLocal = (c) =>
  [c.tdp?.turma?.descricaoAux || c.tdp?.turma?.descricao || "", c.local?.descricao ?? ""].filter(Boolean).join(" · ");

/** Grade semanal do professor (também usada em /cronograma-professor). */
const CronogramaProfessorTableV2 = ({ cronogramas }) => (
  <CronogramaTableV2 cronogramas={cronogramas} detalhe={detalheTurmaLocal} emptyText="Nenhuma aula no cronograma." />
);

export default CronogramaProfessorTableV2;
